import { c } from '#/shared/lib/helpers'
import { FieldError } from 'react-hook-form'
import styles from './common-input.module.scss'
import React, { forwardRef } from 'react'

export type InputVariant = 'outline' | 'primary'

export interface CommonInputProps extends React.InputHTMLAttributes<HTMLInputElement> {
	children?: React.ReactNode
	variant?: InputVariant
	label?: string | React.ReactNode
	error?: FieldError
	rightSlot?: React.ReactNode
	trim?: boolean
}

export const CommonInput = forwardRef<HTMLInputElement, CommonInputProps>(
	(
		{
			rightSlot,
			label,
			error,
			className,
			disabled,
			trim = false,
			variant = 'outline',
			...props
		},
		ref
	) => {
		const onChange = (event: React.ChangeEvent<HTMLInputElement>) => {
			event.target.value = trim ? event.target.value.trim() : event.target.value
		}

		return (
			<div className={styles.box}>
				<div className={styles.header}>
					{label && (
						<label
							className={c(
								styles.label,
								styles[`label_${variant}`],
								error && styles.label_error
							)}
						>
							{label}
						</label>
					)}
				</div>
				<div
					className={c(
						styles.wrapper,
						styles[`wrapper_${variant}`],
						disabled && styles[`wrapper_${variant}_disabled`],
						error && styles.wrapper_error
					)}
				>
					<input
						ref={ref}
						className={c(
							styles.input,
							styles[`input_${variant}`],
							disabled && styles[`input_${variant}_disabled`],
							error && styles.input_error,
							className
						)}
						onChange={onChange}
						disabled={disabled}
						{...props}
					/>
					{rightSlot}
				</div>
				<p className={c(styles.header__error, error && styles.header__error_visible)}>
					{error ? error?.message : ''}
				</p>
			</div>
		)
	}
)
